import React, { useContext } from "react";
import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalContentText,
  ModalTitle,
} from "@deere/fuel-react";
import { useTranslation } from "./translation-context";
import ModalContext from "./modal-context";

const ModalMessage = (props) => {
  const ctx = useContext(ModalContext);
  const handleCloseModal = () => {
    return props.closeModal(false);
  };

  const handleConfirmModal = () => {
    return props.closeModal(true);
  };

  const { translate: t } = useTranslation();
  return (
    <div>
      <Modal open={props.modalOpen} onClose={handleCloseModal}>
        <ModalTitle>{t(props.modalData.title)}</ModalTitle>
        <ModalContent>
          <ModalContentText>{t(props.modalData.contentText)}</ModalContentText>
        </ModalContent>
        <ModalActions>
          <Button variant="secondary" onClick={handleCloseModal}>
            {props.modalData?.buttonCancelText ? t("no") : t("cancel")}
          </Button>
          <Button
            variant="primary"
            disabled={ctx.isDisable ? ctx.isDisable : false}
            onClick={handleConfirmModal}
          >
            {t(props.modalData.buttonText)}
          </Button>
        </ModalActions>
      </Modal>
    </div>
  );
};

export default ModalMessage;
